import React from 'react'
import { useSlateStatic } from 'slate-react'
import { Registry } from '@react-registry'
import { Editor } from 'slate'
import { IndentationIcon } from '../../../utils/Icon'
import { elementCategories } from '../../elementCategories'
import { indentNode, isNodeAtMaxIndent, isNodeAligned, isInTable } from '../utils'
import { indentMultipleListItems } from '../../list/ListItem/utils'
import { ElementWithType } from '../../../../../../../utils/types'

// Shortcut handling for Tab is managed centrally; no per-button shortcut needed

export const Indentation = (props) => {
  const editor = useSlateStatic()

  const handleMouseDown = (event) => {
    event.preventDefault()
    
    const { selection } = editor
    if (selection) {
      const [li] = Editor.nodes(editor, {
        match: (n: ElementWithType) => n.type === 'li',
        mode: 'lowest'
      })
 
      if (li) {
        // Handle list indentation - allow from any cursor position when using icon
        indentMultipleListItems(editor)
      }
      else if (isInTable(editor)) {
        return
      }
      else {
        // Handle regular element indentation - allow from any cursor position when using icon
        indentNode(editor)
      }
    }
  }

  return (
    <React.Fragment>
      {props.children({
        handleMouseDown,
        active: false, // Indent is a boolean operation, never active
        isDisable: {
          func: ({ editor }) => isInTable(editor) || isNodeAligned(editor) || isNodeAtMaxIndent(editor),
          params: { editor }
        }
      })}
    </React.Fragment>
  )
}

Registry.register(
  {
    iconName: <IndentationIcon />,
    category: elementCategories.INDENTATION,
    title: 'Indent',
    template: '',
    IngressComponent: Indentation,
    isContentStackElement: true,
    inBasicToolbar: false,
    canCustomize: false,
    keywords: ['indent']
  },
  { id: 'indent', registry: 'element' }
)

